import { hotList } from '@/mocks/news';

export default function TrendingStrip() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <div className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-100/70 p-4 md:flex-row md:items-center md:gap-6">
        <div className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" aria-hidden="true" />
          </span>
          <div className="leading-tight">
            <p className="font-heading text-base font-bold text-foreground-950">实时热搜</p>
            <p className="text-xs text-foreground-600">每 15 分钟自动更新</p>
          </div>
        </div>

        <div
          className="flex flex-1 flex-wrap items-center gap-2 overflow-hidden"
          aria-label="热搜话题列表"
        >
          {hotList.slice(0, 6).map((h) => (
            <a
              key={h.rank}
              href="#feed"
              className="whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <span className="mr-1 font-semibold text-primary-600">{h.rank}</span>
              {h.title.length > 14 ? `${h.title.slice(0, 14)}…` : h.title}
            </a>
          ))}
        </div>

        <a
          href="#feed"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-800"
        >
          查看更多 <i className="ri-arrow-right-line" aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}